import { render, staticRenderFns } from "./DashboardNavbarLinks.vue?vue&type=template&id=176fce8f"
import script from "./DashboardNavbarLinks.vue?vue&type=script&lang=js"
export * from "./DashboardNavbarLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports